import { Injectable } from '@angular/core';
import { PeopleState, PeopleStore } from './people.store';
import { JsonApiEntityService } from '../jsonentity/json-api-entity.service';
import { HttpClient } from '@angular/common/http';
import { config } from '../../../config/config';
import { ApiService } from '../../services/api/api.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { map } from 'bluebird';

@Injectable({ providedIn: 'root' })
export class PeopleService extends JsonApiEntityService<PeopleState> {

  constructor(
    protected store: PeopleStore,
    protected httpClient: HttpClient,
    private service: ApiService,
  ) {
    super(store);
  }


  submitContactRequest(form: Object): Observable<Account> {
    return this.service.post('tickets', form);
  }

  uploadWeb(id, formData, type = 'avatar') {
    return this.httpClient.post(`${config.api.host}/api/people/${id}/files?type=${type}`, formData);
  }

  uploadVia(id, formData) {
    return this.httpClient.post(`${config.api.host}/api/people/${id}/belastingdienst/via`, formData);
  }
}
